/**
 * Created by emma on 16/11/29.
 */
export const apiUrl = '/api';
export const dicomUrl = '/dicom/api';
export const picUrl = 'http://img.11zhushou.com/';
export const basepath = '';

export const caseStatus = [
    {id: '100', name: '草稿', key: 'allDraft'},
    {id: '201', name: '待接收', key: 'allWaitToTake'},
    {id: '301', name: '待确认', key: 'allWaitToConfirm'},
    {id: '501', name: '被退回', key: 'allRejected'},
    {id: '401', name: '已完成', key: 'allFinished'}
];


// WEBPACK FOOTER //
// ./components/config.js